function formatNumber(n) {
  return n.toString()[1] ? n.toString() : `0${n.toString()}`;
}

/** 星期转化 */
function getWeek(count) {
  const dateArr = ['日', '一', '二', '三', '四', '五', '六'];
  return dateArr[count];
}

/* 时间转化 */
const formatTime = (date) => {
  const year = date.getFullYear();
  const month = formatNumber((date.getMonth() + 1));
  const day = formatNumber(date.getDate());
  const hour = formatNumber(date.getHours());
  const minute = formatNumber(date.getMinutes());
  const week = getWeek(date.getDay());
  return `${year} 年 ${month} 月 ${day} 日   星期${week} ${hour} : ${minute}`;
};

export default {
  formatTime,
};



// WEBPACK FOOTER //
// ./src/lib/util.js